var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-container-base',{attrs:{"title":_vm.title,"id":"dashboard_main"}},[_c('filter-bar-reports',{attrs:{"isDisabled":false}}),_c('table-audio-tags')],1)}
var staticRenderFns = []

export { render, staticRenderFns }